import fetch from "logic/rest/FetchProvider";
import { qualifyUrl } from "util/URLUtils";
import fetchReports from "report/logic/fetchReports";
const retrieveReportsReferencingWidgets = (dashboardId, widgetIds) => fetch(
  "POST",
  qualifyUrl(`/plugins/org.graylog.plugins.report/reports/byWidgets/${dashboardId}`),
  widgetIds
);
const isDashboardPageUsedInReports = async (dashboardId, queryId, widgetIds) => {
  const reports = await fetchReports();
  const reportIds = await retrieveReportsReferencingWidgets(dashboardId, widgetIds[queryId]);
  if ((reportIds == null ? void 0 : reportIds.length) === 1) {
    const reportId = reportIds[0];
    const inaccessibleReport = !reports[reportId];
    const reportTitle = inaccessibleReport ? reportId : `"${reports[reportId].title}"`;
    return window.confirm(
      `One or more widget(s) from this dashboard page are used in ${inaccessibleReport ? "inaccessible " : ""}report ${reportTitle}.

 Do you really want to delete it?`
    );
  }
  if ((reportIds == null ? void 0 : reportIds.length) > 1) {
    const reportTitles = reportIds.map((reportId) => {
      const inAccessibleReport = !reports[reportId];
      const reportTitle = inAccessibleReport ? reportId : `"${reports[reportId].title}"`;
      return `    - ${reportTitle}${inAccessibleReport ? " (not permitted to see title)" : ""}`;
    }).join("\n");
    return window.confirm(
      `One or more widget(s) from this dashboard page are used in reports:
${reportTitles}.

 Do you really want to delete it?`
    );
  }
  return null;
};
export default isDashboardPageUsedInReports;
